const SubscriptionI18n = {
    zh:{
        step1:'第一步：选择产品',
        firstDes1:'在账户页面点击收益宝',
        firstDes2:'选择任意理财产品',
        step2:'第二步：进入UnionDefi界面并连接钱包',
        secondDes1:'点击任意理财产品',
        secondDes2:'确认连接钱包',
        step3:'第三步：输入认购面值',
        thirdDes1:'输入认购数量并点击认购',
        step4:'第四步：购买产品',
        fourthDes1:'钱包签名被唤起，注意选择余额充足的资产支付Gas Fee，然后单击下一步',
        fourthDes2:'单击确认',
        fourthDes3:'输入账户密码',
        fourthDes4:'等待交易',
        fourthDes5:'钱包唤起交易结果',
        step5:'第五步：认购成功',
        fifthDes1:'认购成功后，会自动跳转至您的订单详情页面，届时您的订单将处于“等待中”，启动运行时间您可参考底部倒计时。倒计时结束，订单进入运行，开始收益。',
        step6:'第六步：查看持仓',
        sixthDes:'后续您可以在账户的持仓界面、或收益宝产品页面点击“我的持仓”查看您的理财信息。'
    },
    en:{
        step1:'Step1:Select product',
        firstDes1:'Click Account Yield ',
        firstDes2:'Choose any product',
        step2:'Step2:Enter the UnionDefi interface and connect the wallet',
        secondDes1:'Click on any financial product',
        secondDes2:'Confirm to connect the wallet',
        step3:'Step3:Enter the subscription quantity',
        thirdDes1:'Enter Asset Amount and click “Deposit”” ',
        step4:'Step4:Buy  product',
        fourthDes1:'The wallet signature is invoked. Please ensure you select an asset with sufficient balance to pay the Gas Fee, then click Next.',
        fourthDes2:'Click Transaction “OK”',
        fourthDes3:'Enter the account password',
        fourthDes4:'wait for the transaction',
        fourthDes5:'the wallet invokes the transaction result',
        step5:'Step5:Deposit successful',
        fifthDes1:'After a successful Deposit, you will be automatically redirected to your order details page. At that time, your order will be in "Waiting" status. You can refer to the countdown timer at the bottom for the startup time. Once the countdown ends, the order will enter the running phase and begin generating profits. ',
        step6:'Step6:View position status',
        sixthDes:'You can later view your investment information by clicking "Positions" on the account\'s holdings page or the Yield Treasure product page.'
    }
}
export default SubscriptionI18n